import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import nlNL from "date-fns/locale/nl";

registerLocale("nl-NL", nlNL);

const LocalizedDatePicker =  props => <DatePicker {...props} locale={nlNL} />;

export default LocalizedDatePicker;